/**
 * Dashboard studentProfile にプリセット情報をマージする
 * 基本profileを維持しつつ、プリセットの認知特性を上書き
 */
export function mergePresetIntoProfile(baseProfile, preset) {
  if (!preset || !baseProfile) return baseProfile;

  return {
    // Dashboard固有フィールドを維持 (InteractiveGraph/ChatInterfaceが依存)
    student_id: baseProfile.student_id,
    grade_level: baseProfile.grade_level,
    name: baseProfile.name,
    username: baseProfile.username,
    preferred_learning_style: baseProfile.preferred_learning_style,

    // プリセットで上書きするフィールド
    difficulty_types: baseProfile.difficulty_types,

    cognitive_difficulty: {
      working_memory: preset.cognitive_working_memory || 0,
      visuospatial: preset.cognitive_visuospatial || 0,
      crossmodal: preset.cognitive_crossmodal || 0,
      load_vulnerability: preset.cognitive_load_vulnerability || 0,
      executive_inhibition: preset.cognitive_executive_inhibition || 0,
      language_semantic: preset.cognitive_language_semantic || 0,
      math_anxiety: preset.cognitive_math_anxiety || 0,
      graph_literacy: preset.cognitive_graph_literacy || 0,
    },

    // 教師モード専用メタデータ
    _teacherMode: true,
    _presetId: preset.id,
    _presetSupportLevel: preset.support_level,
    _learningStyle: {
      perception: preset.learning_style_perception,
      input: preset.learning_style_input,
      processing: preset.learning_style_processing,
      understanding: preset.learning_style_understanding,
    },
  };
}
